import { ActivityRetentionHelp, ActivityRetentionSelect } from './ActivityRetentionControl'
import { FormField } from '@/components/templates/entity-form'
import { Input } from '@/components/ui/input'
import { DatePicker } from '@/components/ui/date-time-picker'
import type { useAddConnection } from './useAddConnection'

export function AddConnectionFields({
  state,
  keys,
}: {
  state: ReturnType<typeof useAddConnection>
  keys: boolean
}) {
  return (
    <div className="flex flex-col gap-4">
      <FormField label="Display name" htmlFor="connection-name" required>
        <Input
          id="connection-name"
          value={state.name}
          onChange={(event) => state.setName(event.target.value)}
        />
      </FormField>
      {keys &&
        state.type?.credential_fields.map((field) => {
          const key = field.key ?? field.name.toLowerCase().replaceAll(' ', '_')
          return (
            <FormField
              key={key}
              label={field.name}
              htmlFor={`connection-${key}`}
              required={field.required}
            >
              <Input
                id={`connection-${key}`}
                type={field.secret ? 'password' : 'text'}
                autoComplete="off"
                value={state.credentials[key] ?? ''}
                onChange={(event) =>
                  state.setCredentials({ ...state.credentials, [key]: event.target.value })
                }
              />
            </FormField>
          )
        })}
      <FormField label="Import history from" htmlFor="connection-import">
        <DatePicker
          id="connection-import"
          label="Import history from"
          placeholder="All history"
          value={state.date}
          onChange={state.setDate}
        />
      </FormField>
      {state.retentionSupported && (
        <FormField label="Activity retention" htmlFor="connection-retention">
          <div className="flex flex-col gap-1.5">
            <ActivityRetentionSelect
              id="connection-retention"
              value={state.retention}
              onChange={state.setRetention}
            />
            <p className="text-caption text-muted-foreground">
              <ActivityRetentionHelp country={state.types.data?.legal_identity_country} />
            </p>
          </div>
        </FormField>
      )}
    </div>
  )
}
